import * as types from '../../actions/actionTypes';
import AuthService from '../../services/auth_service';
import { disconnectFirebase } from '../../firebase/actions';
// remove these in future, keeping them for now for current users who have
// these various cache directories created on their devices
import { clearMessageImageCache } from '../messaging/image_cache_deprecated';
import { clearAvatarImageCache } from '../userProfile/image_cache_deprecated';
import { clearCache } from '../components/attachments/file_cache';
import { BASE_URL, env } from '../../constants/env';
import { NEEDS_MFA_SETUP, NEEDS_MFA_CODE } from '../../constants/auth_codes';

export function setMilEnv(isMilEnv) {
  return {
    type: types.SET_MIL_ENV,
    payload: isMilEnv,
  };
}

export function fetchInviteAuthDetails(guid) {
  return {
    types: [
      types.INVITE_AUTH_DETAILS_REQUEST,
      types.INVITE_AUTH_DETAILS_SUCCESS,
      types.INVITE_AUTH_DETAILS_FAILURE,
    ],
    promise: AuthService.fetchInviteAuthDetails(guid).then((response) => {
      return {
        ...response,
        pendingInviteGuid: guid,
      };
    }),
    throwError: true,
  };
}

export function login(email, password, mfaToken) {
  return function (dispatch, getState) {
    // store the base url in redux, we will use this url to log in with
    dispatch({ type: types.SET_BASE_URL, payload: env(BASE_URL) });
    dispatch({ type: types.FORCE_FULL_SYNC });

    email = email.trim().toLowerCase();
    const isAFInvite = getState().application.authFormPrefills?.employerType === 'airforce';

    AuthService.login(email, password, mfaToken)
      .then((response) => {
        if (response.message === NEEDS_MFA_SETUP) {
          return dispatch({ type: types.AUTH_GETMFA_SUCCESS, payload: response });
        } else if (response.message === NEEDS_MFA_CODE) {
          return dispatch({ type: types.AUTH_MISSING_MFA_CODE, payload: response });
        }

        return dispatch({ type: types.AUTH_USER_SUCCESS, payload: { ...response, isAFInvite } });
      })
      .catch((e) => {
        dispatch({ type: types.AUTH_USER_FAILURE, payload: e });
      });
  };
}

export function registerUser(accountObj) {
  return function (dispatch, getState) {
    // store the base url in redux, we will use this url to register
    dispatch({ type: types.SET_BASE_URL, payload: env(BASE_URL) });
    dispatch({ type: types.FORCE_FULL_SYNC });

    accountObj.locale = getState().application.locale;
    accountObj.email = accountObj.email.trim().toLowerCase();
    accountObj.fullname = accountObj.fullname.trim();

    const isAFInvite = getState().application.authFormPrefills?.employerType === 'airforce';

    AuthService.register(accountObj)
      .then((response) => {
        if (response.message === NEEDS_MFA_SETUP) {
          return dispatch({ type: types.AUTH_GETMFA_SUCCESS, payload: response });
        } else if (response.message === NEEDS_MFA_CODE) {
          // I dont think it'll be possible to get here
          return dispatch({ type: types.AUTH_MISSING_MFA_CODE, payload: response });
        }
        return dispatch({ type: types.AUTH_USER_SUCCESS, payload: { ...response, isAFInvite } });
      })
      .catch((e) => {
        dispatch({ type: types.AUTH_USER_FAILURE, payload: e });
      });
  };
}

export function logoutUser(
  disableToken = true,
  intentToResetPassword = false,
  preserveOktaToken = false
) {
  return function (dispatch, getState) {
    clearMessageImageCache();
    clearAvatarImageCache();
    clearCache();

    return dispatch(disconnectFirebase(disableToken))
      .then(() => {
        AuthService.logout({ clearCreds: disableToken });
        return dispatch({
          type: types.UNAUTH_USER,
          payload: { intentToResetPassword, preserveOktaToken },
        });
      })
      .catch((error) => {
        console.warn('Error in disconnectFirebase', error);
        AuthService.logout({ clearCreds: disableToken });
        return dispatch({
          type: types.UNAUTH_USER,
          payload: { intentToResetPassword },
        });
      });
  };
}

export function setReferrer(url) {
  return {
    type: types.SET_REFERRER,
    payload: url,
  };
}

export function forgotPassword(email) {
  if (!email || !email.trim()) return;

  email = email.trim().toLowerCase();
  return {
    types: [
      types.AUTH_FORGOT_PASSWORD_REQUEST,
      types.AUTH_FORGOT_PASSWORD_SUCCESS,
      types.AUTH_FORGOT_PASSWORD_FAILURE,
    ],
    promise: AuthService.forgotPassword(email),
  };
}

export function resetPassword(token, password, mfaToken) {
  return function (dispatch) {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    AuthService.resetPassword(token, password, mfaToken)
      .then((response) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_SUCCESS, payload: response });
      })
      .catch((e) => {
        if (!mfaToken && e.message === 'INVALID_MFA_TOKEN') {
          return dispatch({ type: types.AUTH_MISSING_MFA_CODE, payload: {} });
        } else {
          return dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE, payload: e });
        }
      });
  };
}

export function resetState(options) {
  return function (dispatch) {
    dispatch({ type: types.RESET_AUTH_STATE, payload: options });
  };
}

export function resetMFATokenForEmployerUser(userId, employerId) {
  return {
    types: [
      types.RESET_MFA_TOKEN_REQUEST,
      types.RESET_MFA_TOKEN_SUCCESS,
      types.RESET_MFA_TOKEN_FAILURE,
    ],
    promise: AuthService.resetMFATokenForEmployerUser(userId, employerId),
  };
}

export function requestResetMFA(email, password) {
  if (!email || !email.trim()) return;
  if (!password || !password.trim()) return;

  email = email.trim().toLowerCase();
  password = password.trim();
  return {
    types: [
      types.AUTH_RESET_MFA_REQUEST,
      types.AUTH_RESET_MFA_SUCCESS,
      types.AUTH_RESET_MFA_FAILURE,
    ],
    promise: AuthService.requestResetMFA(email, password),
  };
}

export function acceptOrRejectAFTerms({ accept }) {
  return function (dispatch) {
    if (!accept) {
      dispatch(logoutUser(false));
    } else {
      dispatch({ type: types.AUTH_ACCEPT_AF_TERMS });
    }
  };
}
